import { useEffect, useRef, useState } from 'react'

export function useDelayLoadingState(isLoading: boolean, timeout = 500): boolean {
  const [displayLoading, setDisplayLoading] = useState(isLoading)
  const timer = useRef<number>()

  useEffect(() => {
    clearTimeout(timer.current)

    if (isLoading) {
      timer.current = window.setTimeout(() => {
        setDisplayLoading(true)
      }, timeout)
    } else {
      setDisplayLoading(false)
    }
  }, [isLoading, timeout])

  return displayLoading
}
